import {Order} from "./orderManagement.types";

export const orderManagementModel = ({
                                         accessNumber,
                                         alternateCopyright,
                                         alternateFormat,
                                         author,
                                         catalogFormatId,
                                         copyright,
                                         dateCreatedFormatted,
                                         dateCreatedUtc,
                                         dateOrderReceivedFromVendor,
                                         dateOrderReceivedFromVendorFormatted,
                                         dateOrderSentToVendor,
                                         dateOrderSentToVendorFormatted,
                                         districtName,
                                         format,
                                         gradeLevel,
                                         isbn,
                                         itemName,
                                         needFrom,
                                         needFromFormatted,
                                         needTo,
                                         notes,
                                         orderId,
                                         orderStatus,
                                         orderType,
                                         publisherId,
                                         publisherName,
                                         poNumber,
                                         queueStatus,
                                         seriesTitle,
                                         shelfLocation,
                                         shippingLocationName,
                                         shippingLocationId,
                                         specialInstructions,
                                         studentId,
                                         studentName,
                                         volumes,
                                     }: Partial<Order> = {}): Order => ({
    accessNumber,
    alternateCopyright,
    alternateFormat,
    author,
    catalogFormatId,
    copyright,
    dateCreatedUtc,
    dateCreatedFormatted,
    dateOrderSentToVendor,
    dateOrderSentToVendorFormatted,
    dateOrderReceivedFromVendor,
    dateOrderReceivedFromVendorFormatted,
    districtName,
    format,
    gradeLevel,
    isbn,
    itemName,
    needFrom,
    needFromFormatted,
    needTo,
    notes: notes || ``,
    orderId: orderId ?? "",
    orderType,
    publisherId,
    publisherName,
    orderStatus: orderStatus ?? 0,
    poNumber,
    queueStatus,
    seriesTitle,
    shelfLocation,
    shippingLocationId,
    shippingLocationName,
    specialInstructions: specialInstructions || ``,
    studentId,
    studentName,
    volumes,
});

